import CertificationModuleTitle from "./CertificationCarouselTitle";
import CertificationHeader, {
	CertificationHeaderType,
} from "./CertificationHeader";
import CertificationNotifications from "./CertificationNotifications";
import CardGrid from "~/components/CardGrid";
import { useCertification, useRecommendedCoursePlan } from "~/hooks";
import { toArray } from "~/lib/toArray";
import CoursesCard from "~/pages/courses/components/CoursesCard";

const CertificationRecommendedCoursePlan = () => {
	const { certification } = useCertification();

	const { recommendedCoursePlan } = useRecommendedCoursePlan(
		certification.isLegacy ? undefined : certification.slug,
	);

	const modules = toArray(certification?.modules);

	const getCertificationModule = (slug: string) =>
		modules.find((module) => module.slug === slug);

	return (
		<div className="mt-2 flex w-full flex-col gap-4 xl:gap-6">
			<CertificationHeader
				type={CertificationHeaderType.RECOMMENDED_COURSE_PLAN}
				certification={certification}
			/>

			<CertificationNotifications />

			<div className="flex flex-col gap-6">
				{recommendedCoursePlan.map((coursePlan, i) => (
					<div
						id={coursePlan.slug}
						key={coursePlan._key}
						className="flex laptop:scroll-m-12 scroll-m-20 flex-col gap-2 sm:gap-3"
					>
						{coursePlan.type === "core" ? (
							<CertificationModuleTitle
								href={`/certifications/${certification.slug}/modules/${coursePlan.slug}`}
								module={{
									...getCertificationModule(coursePlan.slug)!,
									title: `${i + 1}. ${
										getCertificationModule(coursePlan.slug)?.title
									}`,
								}}
							/>
						) : (
							<div className="flex items-center gap-2">
								<h2 className="group line-clamp-2 items-center font-medium phablet:font-semibold text-[1.2rem] leading-6 sm:text-2xl">
									{i + 1}. {coursePlan.title}
								</h2>

								<span className="relative ml-auto phablet:ml-0 flex items-center justify-center whitespace-nowrap rounded-full bg-purple-100 px-2.5 py-1 font-semibold phablet:text-sm text-[0.8rem] dark:bg-purple-300/30 dark:text-slate-50">
									Electives
								</span>
							</div>
						)}

						<CardGrid>
							{toArray(coursePlan.courses).map((course) => (
								<div className="card-grid-node-basis" key={course._id}>
									<CoursesCard {...course} />
								</div>
							))}
						</CardGrid>
					</div>
				))}
			</div>
		</div>
	);
};

export default CertificationRecommendedCoursePlan;
